import React from 'react'
import CustomField from '@/components/Form/customFields/CustomField'
import CaluFormInput from '@/components/formComponents/customFields/CaluFormInput'
import { CaluFormSelect } from '@/components/formComponents/customFields/CaluFormSelect'
import { typeOfCategories } from '@/helpers/constants'
import { Grid } from '@mui/material'

import s from './styles.module.scss'

const StepUserDetails = ({ fields }) => {
  return (
    <Grid container spacing={2} className={s.gridContainer}>
      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput name={fields.firstname.name} labelText={fields.firstname.labelText} />
      </Grid>
      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput name={fields.lastname.name} labelText={fields.lastname.labelText} />
      </Grid>

      <Grid item xs={12} className={s.gridItem}>
        <CaluFormSelect
          name={fields.category.name}
          items={typeOfCategories}
          labelText={fields.category.labelText}
          firstOptionValue={'-'}
          firstOptionText={'Seleccione una opción'}
        />
      </Grid>

      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput name={fields.centreName.name} labelText={fields.centreName.labelText} />
      </Grid>
      <Grid item xs={12} className={s.gridItem}>
        <CaluFormInput name={fields.mobile.name} labelText={fields.mobile.labelText} />
      </Grid>
      <CustomField name={fields.botTrap.name} labelText={fields.mobile.labelText} type="hidden" />
    </Grid>
  )
}

export default StepUserDetails
